/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Status of an approval gate
 */
export enum GateStatus {
    CLEARED = 'CLEARED',
    PENDING = 'PENDING',
    REJECTED = 'REJECTED',
}
